"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MDIcon = exports.makeMDIconProps = exports.preloadIcons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var classnames_1 = __importDefault(require("classnames"));
require("./MDIcon.css");
var preloadIcons = function () {
  var icons = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    icons[_i] = arguments[_i];
  }
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, (0, react_1.loadIcons)(icons.map(function (i) {
            return "mdi:".concat(i);
          }))];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
exports.preloadIcons = preloadIcons;
var makeMDIconProps = function (icon) {
  return typeof icon === "string" ? {
    icon: icon
  } : icon;
};
exports.makeMDIconProps = makeMDIconProps;
var MDIcon = function (_a) {
  var _b, _c, _d;
  var icon = _a.icon,
    size = _a.size,
    animation = _a.animation,
    _e = _a.reverse,
    reverse = _e === void 0 ? false : _e,
    align = _a.align,
    _f = _a.inline,
    inline = _f === void 0 ? false : _f,
    rotation = _a.rotation,
    flip = _a.flip,
    color = _a.color,
    className = _a.className,
    background = _a.background,
    border = _a.border,
    borderRadius = _a.borderRadius,
    svgProps = _a.svgProps,
    cursor = _a.cursor,
    refObject = _a.refObject,
    restProps = __rest(_a, ["icon", "size", "animation", "reverse", "align", "inline", "rotation", "flip", "color", "className", "background", "border", "borderRadius", "svgProps", "cursor", "refObject"]);
  var svgStyle = __assign(__assign({}, svgProps === null || svgProps === void 0 ? void 0 : svgProps.style), {
    transform: inline ? "".concat((_c = (_b = svgProps === null || svgProps === void 0 ? void 0 : svgProps.style) === null || _b === void 0 ? void 0 : _b.transform) !== null && _c !== void 0 ? _c : "", " translateY(0.125em)").trim() : (_d = svgProps === null || svgProps === void 0 ? void 0 : svgProps.style) === null || _d === void 0 ? void 0 : _d.transform
  });
  return (0, jsx_runtime_1.jsx)("span", __assign({}, restProps, {
    ref: refObject,
    className: (0, classnames_1.default)("vsx-mdi-icon", className),
    style: __assign({
      verticalAlign: align,
      fontSize: size,
      color: color,
      background: background,
      border: border,
      borderRadius: borderRadius,
      cursor: cursor
    }, restProps.style)
  }, {
    children: (0, jsx_runtime_1.jsx)(react_1.Icon, __assign({}, svgProps, {
      style: svgStyle,
      icon: "mdi:".concat(icon),
      flip: flip,
      className: (0, classnames_1.default)("vsx-mdi-svg", animation && animation !== "none" && "vsx-".concat(animation), reverse && "vsx-reverse"),
      //@ts-ignore
      rotate: rotation
    }))
  }));
};
exports.MDIcon = MDIcon;